import type { MailMessageRow } from "@feedback-hub/contract/browser";

const PROBLEM_STATUSES: ReadonlySet<string> = new Set(["bounced", "complained", "rejected", "delayed"]);

export function filterMessages(
  rows: readonly MailMessageRow[],
  text: string,
  problemsOnly: boolean,
): MailMessageRow[] {
  const needle = text.trim().toLowerCase();
  return rows.filter((r) => {
    if (problemsOnly && !PROBLEM_STATUSES.has(r.status)) return false;
    if (!needle) return true;
    return [r.to, r.from, r.appId, r.status, r.configSet].some(
      (f) => f != null && f.toLowerCase().includes(needle),
    );
  });
}
